import moment from 'shared/lib/moment'

const store = window.booqableStore

export default {

  set: (locale) => {
    const debug = false

    const setLocale = (locale) => {
      window.booqableOptions.locale = locale.split('-')[0]
      moment.locale(locale)
    }

    const loadLocale = (locale) => {
      return import('moment/locale/' + locale).then(() => {
        debug && console.log('    - Locale found and loaded', locale)

        setLocale(locale)
        store.dispatch({ type: 'LOCALE_SET', payload: { locale } })
      })
    }

    const tryLoadLocales = (locales, i = 0) => {
      if (locales[i]) {
        debug && console.log('  - Attempting to load locale', locales[i])

        loadLocale(locales[i]).catch(() => {
          debug && console.log('    - Locale not found', locales[i])

          tryLoadLocales(locales, i + 1)
        })
      } else {
        debug && console.log('    - Locales not found', locales)
      }
    }

    // Use en as default while we load the proper locale
    setLocale('en')

    const [language, substring] = locale.toLowerCase().split('-')
    const locales = []

    // Some of the locales that we construct from language and substring are not present
    // in the moment locale folder https://github.com/moment/moment/tree/develop/locale
    // An error will occur when we try to import those
    const notSupported = ['nb-no']

    if (substring && language !== substring) {
      const localeWithSubstring = [language, substring].join('-')

      if (!notSupported.includes(localeWithSubstring)) {
        locales.push(localeWithSubstring)
      }
    }

    locales.push(language)

    debug && console.log('Detected browser locale', locale)

    // No need to load the default locale
    if (locales.length === 0 || (locales.length === 1 && locales[0] === 'en')) {
      debug && console.log('  - Locale is default en. No need to load any locale')

      return
    }

    debug && console.log('  - Loading locales in order:', locales)

    tryLoadLocales(locales)
  }

}
